module.exports = "<main>\n  <router-outlet></router-outlet>\n</main>\n<app-nav></app-nav>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/logged-in/logged-in.component.html
// module id = 253
// module chunks = 1